import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "billing-page"
}
const _hoisted_2 = { class: "plan-card" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "plan-title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "planButtons"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "payment-methods-container"
}
const _hoisted_9 = { class: "payment-methods" }
const _hoisted_10 = { class: "payment-method" }
const _hoisted_11 = { class: "logo" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "card-placeholder"
}
const _hoisted_14 = { class: "number" }
const _hoisted_15 = { class: "default" }
const _hoisted_16 = {
  key: 0,
  class: "default-marker"
}
const _hoisted_17 = { class: "expires hide-mobile" }
const _hoisted_18 = {
  key: 0,
  class: "delete hide-mobile"
}
const _hoisted_19 = { class: "mobile" }
const _hoisted_20 = { class: "expires" }
const _hoisted_21 = {
  key: 0,
  class: "addPaymentMethod"
}
const _hoisted_22 = {
  key: 1,
  class: "billing-history-container"
}
const _hoisted_23 = { class: "billing-history" }
const _hoisted_24 = { class: "payment" }
const _hoisted_25 = { class: "payment__date col" }
const _hoisted_26 = { class: "payment__amount col" }
const _hoisted_27 = { class: "payment__plan col hide-mobile" }
const _hoisted_28 = { class: "payment__invoice col hide-mobile" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "mobile" }
const _hoisted_31 = { class: "payment__plan col" }
const _hoisted_32 = { class: "payment__invoice col" }
const _hoisted_33 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (!_ctx.billingLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("h4", null, "Current Plan", -1)),
            (_ctx.currentPlan.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.currentPlan.name), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(_ctx.currentPlan.pricePerMonth.toFixed(2)) + " per month ", 1),
                  _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.subscriptionDescription), 1),
                  (_ctx.subscriptionActive)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                        _cache[2] || (_cache[2] = _createTextVNode(" Your next payment will be taken on ", -1)),
                        _createElementVNode("u", null, _toDisplayString(_ctx.paymentDate), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.subscriptionActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_ctx.falseHide)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "upgradePlanButton",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('upgrade-plan-click')))
                            }, " Upgrade Plan "))
                          : _createCommentVNode("", true),
                        _createVNode(_component_router_link, {
                          to: "/users/create",
                          class: "addUsersButton"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("Add Users", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("button", {
                          class: "cancelPlanButton",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelPlan && _ctx.cancelPlan(...args)))
                        }, " Cancel Plan ")
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("p", null, " ", -1),
                  _createElementVNode("h2", { class: "plan-title" }, "Subscription not found", -1),
                  _createElementVNode("p", null, " ", -1)
                ]))]))
          ]),
          (_ctx.currentPlan.name && _ctx.subscriptionActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", null, "Payment Method", -1)),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.acceptedMethods.includes(method.type))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "paymentMethodLogo",
                                src: require(`@/assets/img/${method.type}.svg`)
                              }, null, 8, _hoisted_12))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", null, _toDisplayString(method.code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          (method.default)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Default"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("span", null, "Expires " + _toDisplayString(method.expires), 1)
                        ]),
                        (_ctx.falseHide)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_font_awesome_icon, { icon: "times" })
                            ]))
                          : _createCommentVNode("", true),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, [
                          _createTextVNode(" Expires " + _toDisplayString(method.expires) + " ", 1),
                          (_ctx.falseHide)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                class: "icon",
                                icon: "times"
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64))
                  }), 128))
                ]),
                (_ctx.falseHide)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_21, "+ Add payment method"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentPlan.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Billing History", -1)),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingHistory, (payment, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("span", null, _toDisplayString(payment.date), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(payment.amount.toFixed(2)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", null, _toDisplayString(payment.plan), 1)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("a", {
                            href: payment.invoiceUrl,
                            target: "_blank"
                          }, "View invoice", 8, _hoisted_29)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", null, _toDisplayString(payment.plan), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("a", {
                            href: payment.invoiceUrl
                          }, "View invoice", 8, _hoisted_33)
                        ])
                      ])
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}